import React, { useEffect, useState } from "react";
import EmployeeGeneralInformation from "./EmployeeGeneralInfo";
import EmploymentInformation from "./EmploymentInfo";
import PayrollInformation from "./PayrollInfo";
import Companysteps from "./Steps";
import * as utilities from "../../utilities/utils";
import { initialState } from "./initialState";
import validation from "../../utilities/validation";

function CompanyComponent(props) {
  const [state, setState] = useState(initialState);

  //Set initial step count after first render
  useEffect(() => {
    props.setMaxStep(3);
    props.setMinStep(1);
    props.setCurrentFormStep(1);
  }, []);

  // Execute function on set count change
  useEffect(() => onStepCountChange(), [props.stepCount]);

  const handleChanges = (event) => {
    let { name, value, checked, type } = event.target;

    let updatedObj = state[name];
    updatedObj.value = type === "checkbox" ? checked : value;

    if (state.isSubmitOnce.value) FormValidation();

    setState((state) => {
      return {
        ...state,
        [name]: updatedObj,
      };
    });
  };

  const onDateChange = (value, name) => {
    let updatedObj = state[name];
    updatedObj.value = value;

    if (state.isSubmitOnce.value) FormValidation();

    setState((state) => {
      return { ...state, [name]: updatedObj };
    });
  };

  const normalizeInput = (value, previousValue) => {
    if (!value) return value;

    //remove any charater without alphnumeric
    const currentValue = value.replace(/[^\a-zA-Z0-9]/g, "");
    const cvLength = currentValue.length;

    if (!previousValue || value.length) {
      if (cvLength < 4) {
        return currentValue;
      } else if (cvLength < 7) {
        return `(${currentValue.slice(0, 3)})-${currentValue.slice(3)}`;
      } else {
        return `(${currentValue.slice(0, 3)})-${currentValue.slice(
          3,
          6
        )}-${currentValue.slice(6, 10)}`;
      }
    }
  };

  const handlePhoneNumber = (event) => {
    let { name, value, checked, type } = event.target;

    let updatedObj = state[name];
    updatedObj.value = type === "checkbox" ? checked : value;

    if (state.isSubmitOnce.value) FormValidation();

    setState((previousState) => {
      return {
        ...previousState,
        [name]: utilities.convertIntoObject(
          normalizeInput(updatedObj.value, previousState[name][value]),
          previousState[name]
        ),
      };
    });
  };

  const onTimeChange = (name, value) => {
    let updatedObj = state[name];
    updatedObj.value = value;

    if (state.isSubmitOnce.value) FormValidation();

    setState((state) => {
      return { ...state, [name]: updatedObj };
    });
  };

  const onDropDownChange = (event) => {
    let { name, value } = event;

    let updatedObj = state[name];
    updatedObj.value = value;

    if (state.isSubmitOnce.value) FormValidation();

    setState((state) => {
      return { ...state, [name]: updatedObj };
    });
  };

  const hideComponent = (event) => {
    let { name, value } = event.target;
  };
  const FormValidation = () => {
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        let validatedObj = validation(state[property], props.context);

        setState((state) => {
          return {
            ...state,
            [property]: validatedObj,
          };
        });
      }
    }
  };

  const isFormValid = (currentStepCount) => {
    let isValid = true;
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        if (
          state[property]?.error.length > 0 &&
          currentStepCount === state[property]?.step
        ) {
          isValid = false;
        }
      }
    }
    return isValid;
  };

  /// Validation showing in advance in another form steps
  const onStepCountChange = () => {
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        if (
          state[property]?.error.length > 0 &&
          state[property]?.step === props.stepCount
        ) {
          state[property].error = "";
          setState((previousState) => {
            return {
              ...previousState,
              [property]: state[property],
              isSubmitOnce: utilities.convertIntoObject(false),
            };
          });
        }
      }
    }
  };

  const onSubmit = () => {
    setState((state) => {
      return {
        ...state,
        isSubmitOnce: utilities.convertIntoObject(true),
      };
    });
    FormValidation();
    if (isFormValid(props.stepCount)) {
      nextStep();
    }

    // nextStep();
    utilities.scrollToTop();
  };

  const nextStep = () => {
    if (props.stepCount < props.maxStep) {
      props.setCurrentFormStep(props.stepCount + 1);
    }
  };

  const previousStep = () => {
    if (props.stepCount > props.minStep) {
      props.setCurrentFormStep(props.stepCount - 1);
      utilities.scrollToTop();
    }
  };

  switch (props?.stepCount) {
    case 1:
      return (
        <>
          <Companysteps
            currentStep={props.stepCount}
            setCurrentFormStep={props.setCurrentFormStep}
          />
          <EmployeeGeneralInformation
            onDateChange={onDateChange}
            onDropDownChange={onDropDownChange}
            handleChanges={handleChanges}
            state={state}
            nextStep={nextStep}
            previousStep={previousStep}
            onSubmit={onSubmit}
          />
        </>
      );
    case 2:
      return (
        <>
          <Companysteps
            currentStep={props.stepCount}
            setCurrentFormStep={props.setCurrentFormStep}
          />

          <EmploymentInformation
            onDateChange={onDateChange}
            onDropDownChange={onDropDownChange}
            handleChanges={handleChanges}
            state={state}
            nextStep={nextStep}
            previousStep={previousStep}
            onSubmit={onSubmit}
          />
        </>
      );
    case 3:
      return (
        <>
          <Companysteps
            currentStep={props.stepCount}
            setCurrentFormStep={props.setCurrentFormStep}
          />
          <PayrollInformation
            onDateChange={onDateChange}
            onDropDownChange={onDropDownChange}
            handleChanges={handleChanges}
            state={state}
            nextStep={nextStep}
            previousStep={previousStep}
            onSubmit={onSubmit}
          />
        </>
      );
    default:
      return null;
  }
}

export default CompanyComponent;
